import { Flex, Heading, Sidebar, Skeleton } from '@buffer-mono/popcorn'

import { ListHeaderIcon } from '../ListHeader/ListHeaderIcon'

import styles from './ListHeaderV2.module.css'

import type { JSX } from 'react'

type ListHeaderTitleV2Props = {
  title: string
  isLoading: boolean
  isCollection: boolean
  domain?: string
}

export const ListHeaderTitleV2 = ({
  title,
  isCollection,
  domain,
  isLoading,
}: ListHeaderTitleV2Props): JSX.Element => {
  return (
    <Flex align="center" gap="sm">
      <Sidebar.Trigger className={styles.sidebarTrigger} />
      <ListHeaderIcon
        title={title}
        isCollection={isCollection}
        domain={domain}
        isLoading={isLoading}
      />
      {isLoading ? (
        <Skeleton width={200} height={32} className={styles.skeletonNoShrink} />
      ) : (
        <Heading as="h2" size="small" truncate="ellipsis">
          {title}
        </Heading>
      )}
    </Flex>
  )
}
